'use client'
const ZERO_DEV_LAST_USED_CHAIN_ID_KEY = 'dynamic_zerodev_last_used_chain_id';

export { ZERO_DEV_LAST_USED_CHAIN_ID_KEY };
